import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Button, Checkbox, Stack, Typography } from "@mui/material"
import { addPSECookingWithoutFishParasiteEvent } from "../../actions/ProductionSteps/ProductionStepExecutions"

const StepCompletionCookingsFooter = ({
  pseId,
  hasCookingPSEFamilyIngredientFish,
  buttonText,
  onSubStatusChange
}) => {
  const [acceptNoFishParasite, setAcceptNoFishParasite] = useState(false)

  const dispatch = useDispatch()

const handleCheckHasParasiteInFish = (e) => {
    const checked = e.target.checked
    setAcceptNoFishParasite(checked)
    if (!checked) return
    dispatch(addPSECookingWithoutFishParasiteEvent(pseId))
  }

  return (
    <Stack direction="row" spacing={2} alignItems={"center"} alignSelf="stretch" width="100%" justifyContent={hasCookingPSEFamilyIngredientFish ? "space-between" : "flex-end"}>
        {hasCookingPSEFamilyIngredientFish && (
        <Stack direction="row" spacing={1} alignItems="center">
            <Checkbox
            checked={acceptNoFishParasite}
            onChange={handleCheckHasParasiteInFish}
            />
            <Typography>
            J'atteste avoir fait un contrôle visuel et qu'aucun parasite n'est présent sur le poisson.
            </Typography>
        </Stack>
        )}
        <Button variant="contained" onClick={onSubStatusChange} disabled={hasCookingPSEFamilyIngredientFish && !acceptNoFishParasite} sx={{ marginLeft: "auto" }}>
            {buttonText}
        </Button>
    </Stack>
  )
}

export default StepCompletionCookingsFooter